import { Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { int32_type, record_type, option_type, float64_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { empty, singleton, append, isEmpty, tryFind, tryHead, concat, min as min_1, max, ofArray, head, toArray, length, item, mapIndexed, map } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { localFormat } from "./fable_modules/Fable.Date.1.0.0/Date.Format.fs.js";
import { french } from "./fable_modules/Fable.Date.1.0.0/Date.Local.fs.js";
import { compare, toString, toLocalTime } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { substring, toConsole, split, printf, toText } from "./fable_modules/fable-library-js.4.24.0/String.js";
import * as react from "react";
import { LineChart, Legend, Tooltip, YAxis, XAxis, CartesianGrid, Line } from "recharts";
import { parse } from "./fable_modules/fable-library-js.4.24.0/Int32.js";
import { mapIndexed as mapIndexed_1, item as item_1 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { int32ToString, comparePrimitives } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { map as map_1, delay, toArray as toArray_1 } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { rangeDouble } from "./fable_modules/fable-library-js.4.24.0/Range.js";

export function valueExtractor(_arg) {
    switch (_arg.tag) {
        case 2:
            return _arg.fields[0];
        case 1:
            throw new Error("not handled");
        default:
            return _arg.fields[0];
    }
}

export class SimpleChartData extends Record {
    constructor(date, v1, v2, v3, v4) {
        super();
        this.date = date;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
        this.v4 = v4;
    }
}

export function SimpleChartData_$reflection() {
    return record_type("RechartsHelper.SimpleChartData", [], SimpleChartData, () => [["date", string_type], ["v1", option_type(float64_type)], ["v2", option_type(float64_type)], ["v3", option_type(float64_type)], ["v4", option_type(float64_type)]]);
}

export class MultiChartData extends Record {
    constructor(dateIndex, date, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20) {
        super();
        this.dateIndex = (dateIndex | 0);
        this.date = date;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
        this.v4 = v4;
        this.v5 = v5;
        this.v6 = v6;
        this.v7 = v7;
        this.v8 = v8;
        this.v9 = v9;
        this.v10 = v10;
        this.v11 = v11;
        this.v12 = v12;
        this.v13 = v13;
        this.v14 = v14;
        this.v15 = v15;
        this.v16 = v16;
        this.v17 = v17;
        this.v18 = v18;
        this.v19 = v19;
        this.v20 = v20;
    }
}

export function MultiChartData_$reflection() {
    return record_type("RechartsHelper.MultiChartData", [], MultiChartData, () => [["dateIndex", int32_type], ["date", string_type], ["v1", option_type(float64_type)], ["v2", option_type(float64_type)], ["v3", option_type(float64_type)], ["v4", option_type(float64_type)], ["v5", option_type(float64_type)], ["v6", option_type(float64_type)], ["v7", option_type(float64_type)], ["v8", option_type(float64_type)], ["v9", option_type(float64_type)], ["v10", option_type(float64_type)], ["v11", option_type(float64_type)], ["v12", option_type(float64_type)], ["v13", option_type(float64_type)], ["v14", option_type(float64_type)], ["v15", option_type(float64_type)], ["v16", option_type(float64_type)], ["v17", option_type(float64_type)], ["v18", option_type(float64_type)], ["v19", option_type(float64_type)], ["v20", option_type(float64_type)]]);
}

export class Payload extends Record {
    constructor(name, value) {
        super();
        this.name = name;
        this.value = value;
    }
}

export function Payload_$reflection() {
    return record_type("RechartsHelper.Payload", [], Payload, () => [["name", string_type], ["value", float64_type]]);
}

export function dataFromSensorValues(values) {
    const extractV1 = (data) => map((value) => {
        const v = valueExtractor(value.Value);
        const date_1 = localFormat(french, "dd/MM HH:mm", toLocalTime(value.Date));
        return new SimpleChartData(toText(printf("%s"))(date_1), v, undefined, undefined, undefined);
    }, data);
    const extractNext = (newValues, which, previousvalues) => mapIndexed((i, value_1) => {
        const v_1 = valueExtractor(value_1.Value);
        const previous = item(i, previousvalues);
        switch (which) {
            case 1:
                return new SimpleChartData(previous.date, v_1, previous.v2, previous.v3, previous.v4);
            case 2:
                return new SimpleChartData(previous.date, previous.v1, v_1, previous.v3, previous.v4);
            case 3:
                return new SimpleChartData(previous.date, previous.v1, previous.v2, v_1, previous.v4);
            default:
                return new SimpleChartData(previous.date, previous.v1, previous.v2, previous.v3, v_1);
        }
    }, newValues);
    const matchValue = length(values) | 0;
    switch (matchValue) {
        case 0:
            return [];
        case 1:
            return toArray(extractV1(head(values).List));
        case 2:
            return toArray(extractNext(item(1, values).List, 2, extractV1(item(0, values).List)));
        case 3:
            return toArray(extractNext(item(2, values).List, 3, extractNext(item(1, values).List, 2, extractV1(item(0, values).List))));
        default:
            return toArray(extractNext(item(3, values).List, 4, extractNext(item(2, values).List, 3, extractNext(item(1, values).List, 2, extractV1(item(0, values).List)))));
    }
}

export function graph(data, kind) {
    let props_4, props_6, props_8, props_10, props_12;
    const currentDomain = (kind.tag === 37) ? ["dataMin - 1.5", "dataMax + 1.5"] : ((kind.tag === 1) ? ["dataMin - 1.5", "dataMax + 1.5"] : ((kind.tag === 38) ? ["dataMin - 1.5", "dataMax + 1.5"] : ((kind.tag === 2) ? ["dataMin - 1.5", "dataMax + 1.5"] : ["dataMin", "dataMax"])));
    const values_1 = dataFromSensorValues(data);
    let patternInput;
    const matchValue = length(data) | 0;
    patternInput = ((matchValue === 1) ? [item(0, data).Name, ".", ".", "."] : ((matchValue === 2) ? [item(0, data).Name, item(1, data).Name, ".", "."] : ((matchValue === 3) ? [item(0, data).Name, item(1, data).Name, item(2, data).Name, "."] : [item(0, data).Name, item(1, data).Name, item(2, data).Name, item(3, data).Name])));
    const makeLine = (color, key, sw, name) => {
        if (name === ".") {
            return react.createElement(react.Fragment, {});
        }
        else {
            const props_2 = {
                type: "linear",
                dataKey: key,
                dot: false,
                stroke: color,
                strokeWidth: sw,
                name: name,
            };
            return react.createElement(Line, props_2);
        }
    };
    const children_13 = ofArray([makeLine("black", "v1", 1, patternInput[0]), makeLine("blue", "v2", 1, patternInput[1]), makeLine("green", "v3", 1, patternInput[2]), makeLine("orange", "v4", 1, patternInput[3]), (props_4 = {
        stroke: "rgba(255,255,255,0.1)",
        strokeWidth: 1,
    }, react.createElement(CartesianGrid, props_4)), (props_6 = {
        dataKey: "date",
        strokeWidth: 0,
        stroke: "black",
    }, react.createElement(XAxis, props_6)), (props_8 = {
        tickFormatter: (tick) => {
            const unit = (kind.tag === 37) ? "°C" : ((kind.tag === 1) ? "°C" : ((kind.tag === 38) ? "°C" : ((kind.tag === 2) ? "°C" : "")));
            return toText(printf("%.2f %s"))(tick)(unit);
        },
        tickLine: true,
        strokeWidth: 0.1,
        stroke: "black",
        domain: ["dataMin - 1.5", "dataMax + 1.5"],
        domain: currentDomain,
        allowDecimals: false,
    }, react.createElement(YAxis, props_8)), (props_10 = {}, react.createElement(Tooltip, props_10)), (props_12 = {
        verticalAlign: "top",
    }, react.createElement(Legend, props_12))]);
    const props_14 = {
        width: 300,
        height: 300,
        data: values_1,
    };
    return react.createElement(LineChart, props_14, ...children_13);
}

export function multiDataFromSensorValues(values) {
    const toIntegerIndex = (date) => {
        const date_2 = split(toString(date, "HH:mm"), [":"], undefined, 0);
        return ((parse(item_1(0, date_2), 511, false, 32) * 100) + parse(item_1(1, date_2), 511, false, 32)) | 0;
    };
    const minDate = max(map((x_3) => x_3[1], map((x) => [x.Name, min_1(map(toIntegerIndex, map((x_1) => toLocalTime(x_1.Date), x.List)), {
        Compare: comparePrimitives,
    })], values)), {
        Compare: comparePrimitives,
    }) | 0;
    const maxDate = toIntegerIndex(max(map((x_6) => toLocalTime(x_6.Date), concat(map((x_5) => x_5.List, values))), {
        Compare: compare,
    })) | 0;
    toConsole(printf("minDate %A maxDate %A"))(minDate)(maxDate);
    const narrow = (dateInt) => {
        if ((dateInt % 5) === 0) {
            return dateInt | 0;
        }
        else {
            return (dateInt - (dateInt % 5)) | 0;
        }
    };
    const minDate_1 = narrow(minDate) | 0;
    const maxDate_1 = narrow(maxDate) | 0;
    toConsole(printf("minDate %A maxDate %A"))(minDate_1)(maxDate_1);
    let indexes;
    const array = toArray_1(delay(() => map_1((i) => i, rangeDouble(minDate_1, 5, maxDate_1))));
    indexes = array.filter((x_8) => ((x_8 % 100) <= 55));
    toConsole(printf("indexes %A"))(indexes);
    const initialValues = mapIndexed_1((i_1, x_9) => {
        const date_4 = int32ToString(x_9);
        return {
            date: (x_9 < 1000) ? ((("0" + substring(date_4, 0, 1)) + ":") + substring(date_4, 1, 2)) : ((substring(date_4, 0, 2) + ":") + substring(date_4, 2, 2)),
            dateIndex: x_9,
            index: i_1,
        };
    }, indexes);
    const blank = () => (new MultiChartData(0, ".", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
    const fill = (probeIndex, v, previous) => {
        switch (probeIndex) {
            case 1:
                return new MultiChartData(previous.dateIndex, previous.date, v, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 2:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, v, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 3:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, v, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 4:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, v, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 5:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, v, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 6:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, v, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 7:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, v, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 8:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, v, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 9:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, v, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 10:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, v, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 11:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, v, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 12:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, v, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 13:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, v, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 14:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, v, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 15:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, v, previous.v16, previous.v17, previous.v18, previous.v19, previous.v20);
            case 16:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, v, previous.v17, previous.v18, previous.v19, previous.v20);
            case 17:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, v, previous.v18, previous.v19, previous.v20);
            case 18:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, v, previous.v19, previous.v20);
            case 19:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, v, previous.v20);
            case 20:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, v);
            default:
                return new MultiChartData(previous.dateIndex, previous.date, previous.v1, previous.v2, previous.v3, previous.v4, previous.v5, previous.v6, previous.v7, previous.v8, previous.v9, previous.v10, previous.v11, previous.v12, previous.v13, previous.v14, previous.v15, previous.v16, previous.v17, previous.v18, previous.v19, v);
        }
    };
    const next = (i_4_mut, values_1_mut, previous_4_mut) => {
        let probeIndex_1, previous_1, data, initialValue, v_23, check;
        next:
        while (true) {
            const i_4 = i_4_mut, values_1 = values_1_mut, previous_4 = previous_4_mut;
            if (i_4 >= length(values_1)) {
                return previous_4;
            }
            else {
                i_4_mut = (i_4 + 1);
                values_1_mut = values_1;
                previous_4_mut = ((probeIndex_1 = ((i_4 + 1) | 0), (previous_1 = previous_4, (data = mapIndexed((i_2, value_2) => {
                    const v_22 = valueExtractor(value_2.Value);
                    return {
                        dateIndex: narrow(toIntegerIndex(toLocalTime(value_2.Date))),
                        value: v_22,
                    };
                }, item(i_4, values_1).List), (initialValue = ((v_23 = tryHead(data), (v_23 == null) ? 0 : v_23.value)), (toConsole(printf("initialValue %A"))(initialValue), (check = ((index_mut, prev_mut, prevValues_mut) => {
                    check:
                    while (true) {
                        const index = index_mut, prev = prev_mut, prevValues = prevValues_mut;
                        if (index >= initialValues.length) {
                            return prevValues;
                        }
                        else {
                            const currentInitialValue = item_1(index, initialValues);
                            const dateIndex_1 = currentInitialValue.dateIndex | 0;
                            const date_7 = currentInitialValue.date;
                            toConsole(printf("initial dateIndex %A"))(dateIndex_1);
                            toConsole(printf("date %A"))(date_7);
                            let patternInput;
                            const matchValue = tryFind((x_50) => (x_50.dateIndex === dateIndex_1), data);
                            if (matchValue == null) {
                                if (isEmpty(prevValues)) {
                                    toConsole(printf("STALE %A"))(dateIndex_1);
                                    const result_3 = fill(probeIndex_1, prev, blank());
                                    patternInput = [new MultiChartData(dateIndex_1, date_7, result_3.v1, result_3.v2, result_3.v3, result_3.v4, result_3.v5, result_3.v6, result_3.v7, result_3.v8, result_3.v9, result_3.v10, result_3.v11, result_3.v12, result_3.v13, result_3.v14, result_3.v15, result_3.v16, result_3.v17, result_3.v18, result_3.v19, result_3.v20), prev];
                                }
                                else {
                                    try {
                                        toConsole(printf("STALE %A"))(dateIndex_1);
                                        const result_4 = fill(probeIndex_1, prev, item(index, prevValues));
                                        patternInput = [new MultiChartData(dateIndex_1, date_7, result_4.v1, result_4.v2, result_4.v3, result_4.v4, result_4.v5, result_4.v6, result_4.v7, result_4.v8, result_4.v9, result_4.v10, result_4.v11, result_4.v12, result_4.v13, result_4.v14, result_4.v15, result_4.v16, result_4.v17, result_4.v18, result_4.v19, result_4.v20), prev];
                                    }
                                    catch (matchValue_2) {
                                        toConsole(printf("FIRST %A"))(prev);
                                        const result_5 = fill(probeIndex_1, prev, blank());
                                        patternInput = [new MultiChartData(dateIndex_1, date_7, result_5.v1, result_5.v2, result_5.v3, result_5.v4, result_5.v5, result_5.v6, result_5.v7, result_5.v8, result_5.v9, result_5.v10, result_5.v11, result_5.v12, result_5.v13, result_5.v14, result_5.v15, result_5.v16, result_5.v17, result_5.v18, result_5.v19, result_5.v20), prev];
                                    }
                                }
                            }
                            else {
                                const value_4 = matchValue;
                                toConsole(printf("value %A %A"))(value_4.dateIndex)(value_4.value);
                                if (isEmpty(prevValues)) {
                                    toConsole(printf("NEW %A"))(value_4.value);
                                    const result = fill(probeIndex_1, value_4.value, blank());
                                    patternInput = [new MultiChartData(dateIndex_1, date_7, result.v1, result.v2, result.v3, result.v4, result.v5, result.v6, result.v7, result.v8, result.v9, result.v10, result.v11, result.v12, result.v13, result.v14, result.v15, result.v16, result.v17, result.v18, result.v19, result.v20), value_4.value];
                                }
                                else {
                                    try {
                                        const result_1 = fill(probeIndex_1, value_4.value, item(index, prevValues));
                                        toConsole(printf("UPDATE %A"))(value_4.value);
                                        patternInput = [new MultiChartData(dateIndex_1, date_7, result_1.v1, result_1.v2, result_1.v3, result_1.v4, result_1.v5, result_1.v6, result_1.v7, result_1.v8, result_1.v9, result_1.v10, result_1.v11, result_1.v12, result_1.v13, result_1.v14, result_1.v15, result_1.v16, result_1.v17, result_1.v18, result_1.v19, result_1.v20), value_4.value];
                                    }
                                    catch (matchValue_1) {
                                        toConsole(printf("FIRST %A"))(value_4.value);
                                        const result_2 = fill(probeIndex_1, value_4.value, blank());
                                        patternInput = [new MultiChartData(dateIndex_1, date_7, result_2.v1, result_2.v2, result_2.v3, result_2.v4, result_2.v5, result_2.v6, result_2.v7, result_2.v8, result_2.v9, result_2.v10, result_2.v11, result_2.v12, result_2.v13, result_2.v14, result_2.v15, result_2.v16, result_2.v17, result_2.v18, result_2.v19, result_2.v20), value_4.value];
                                    }
                                }
                            }
                            const result_6 = patternInput[0];
                            index_mut = (index + 1);
                            prev_mut = patternInput[1];
                            prevValues_mut = (isEmpty(previous_1) ? ((toConsole(printf("LIST ADD")), append(prevValues, singleton(result_6)))) : ((toConsole(printf("LIST UPDATE")), mapIndexed((i_3, x_51) => {
                                if (i_3 === index) {
                                    return result_6;
                                }
                                else {
                                    return x_51;
                                }
                            }, prevValues))));
                            continue check;
                        }
                        break;
                    }
                }), check(0, initialValue, previous_1))))))));
                continue next;
            }
            break;
        }
    };
    if (length(values) === 0) {
        return [];
    }
    else {
        const result_7 = toArray(next(0, values, empty()));
        toConsole(printf("result %A"))(result_7);
        return result_7;
    }
}

export function multiGraph(data, kind) {
    let props_5, props_7, props_9, props_11, props_13;
    const currentDomain = (kind.tag === 37) ? ["dataMin - 1.5", "dataMax + 1.5"] : ((kind.tag === 1) ? ["dataMin - 1.5", "dataMax + 1.5"] : ((kind.tag === 38) ? ["dataMin - 1.5", "dataMax + 1.5"] : ((kind.tag === 2) ? ["dataMin - 1.5", "dataMax + 1.5"] : ["dataMin", "dataMax"])));
    const values_1 = multiDataFromSensorValues(data);
    const lines = mapIndexed((i, label) => {
        const color = item(i, ofArray(["black", "blue", "green", "orange", "red", "purple", "yellow", "pink", "brown", "grey", "cyan", "magenta", "lime", "teal", "navy", "maroon", "olive", "silver", "gold", "coral", "salmon", "plum", "khaki", "lavender", "peachpuff", "lightblue", "lightgreen", "lightpink", "lightyellow", "lightgrey", "lightsalmon", "lightcoral", "lightcyan", "lightseagreen"]));
        let key;
        const arg = (i + 1) | 0;
        key = toText(printf("v%i"))(arg);
        const name = label;
        if (name === ".") {
            return react.createElement(react.Fragment, {});
        }
        else {
            const props_2 = {
                type: "linear",
                dataKey: key,
                dot: false,
                stroke: color,
                strokeWidth: 1,
                name: name,
            };
            return react.createElement(Line, props_2);
        }
    }, map((x) => x.Name, data));
    const children_14 = ofArray([react.createElement(react.Fragment, {}, ...lines), (props_5 = {
        stroke: "rgba(255,255,255,0.1)",
        strokeWidth: 1,
    }, react.createElement(CartesianGrid, props_5)), (props_7 = {
        dataKey: "date",
        strokeWidth: 0,
        stroke: "black",
    }, react.createElement(XAxis, props_7)), (props_9 = {
        tickFormatter: (tick) => {
            const unit = (kind.tag === 37) ? "°C" : ((kind.tag === 1) ? "°C" : ((kind.tag === 38) ? "°C" : ((kind.tag === 2) ? "°C" : "")));
            return toText(printf("%.2f %s"))(tick)(unit);
        },
        tickLine: true,
        strokeWidth: 0.1,
        stroke: "black",
        domain: ["dataMin - 1.5", "dataMax + 1.5"],
        domain: currentDomain,
        allowDecimals: false,
    }, react.createElement(YAxis, props_9)), (props_11 = {}, react.createElement(Tooltip, props_11)), (props_13 = {
        verticalAlign: "top",
    }, react.createElement(Legend, props_13))]);
    const props_15 = {
        width: 1900,
        height: 500,
        data: values_1,
    };
    return react.createElement(LineChart, props_15, ...children_14);
}

